import { checkPassStrength } from "./utils";

const $ = window.jQuery;
const modal = $("#js-popup-modal");
const enterInputs = $(".form-group input");

export default function user() {
	$(document).on("blur", ".enter__input", e => {
		const element = e.currentTarget;
		$(element).removeClass("not-empty");
		if ($(element).val()) {
			$(element).addClass("not-empty");
		}
	});

	$(document).on("mouseenter", ".enter__input", e => {
		const element = e.currentTarget;
		$(element).addClass("hover");
	});

	$(document).on("mouseleave", ".enter__input", e => {
		const element = e.currentTarget;
		$(element).removeClass("hover");
	});

	modal.on("show.bs.modal", () => {
		$(".body").css("overflow", "hidden");
	});

	modal.on("hide.bs.modal", () => {
		$(".body").css("overflow", "");
	});

	$(document).on("click", ".js-enter-visible-password", e => {
		const element = $(e.currentTarget);
		const input = element.parents(".enter__block").find(".enter__input");
		element.toggleClass("active");

		if (input.attr("type") === "text") {
			input.attr("type", "password");
		} else {
			input.attr("type", "text");
		}
	});

	$(".checkbox__input").on("keydown", e => {
		const element = $(e.currentTarget);

		if (e.code === "Enter" || e.code === "NumpadEnter") {
			element.toggleClass("checked");
		}
	});

	$(document).on("click", ".js-login-back", () => {
		$("#recoveryModal").modal("hide");
		$("#loginModal").modal("show");
	});

	$(".js-enter-register").on("click", () => {
		$("#loginModal").modal("hide");
	});

	$(".js-enter-recovery").on("click", () => {
		$("#loginModal").modal("hide");
	});

	$(".js-enter-login").on("click", () => {
		$("#registerModal").modal("hide");
	});

	$(".places__close").on("click", () => {
		if (window.location.pathname.includes("event")) {
			window.location.assign("/");
		}
	});

	$.each(enterInputs, (i, item) => {
		const element = $(item);
		if (element.val()) {
			element.next().addClass("inactive");
		}
	});

	enterInputs.on("input", e => {
		const element = $(e.currentTarget);
		element.next().addClass("inactive");
		if (!element.val()) {
			element.next().removeClass("inactive");
		}
	});

	enterInputs.on("click", e => {
		const element = $(e.currentTarget);
		element.next().addClass("inactive");
	});

	enterInputs.on("blur", e => {
		const element = $(e.currentTarget);
		if (!element.val()) {
			element.next().removeClass("inactive");
		}
	});

	function removeExtraLinks(id) {
		const links = $(".tabs_cart .tabs__link");
		$.each(links, (item, element) => {
			$(element)
				.parents(".tabs__item ")
				.hide();

			if ($(element).attr("id") === id) {
				$(element)
					.parents(".tabs__item ")
					.show();
			}
		});
	}

	function actionToTab(name) {
		if (window.location.hash === `#${name}` || window.location.search.includes(`tab=${name}`)) {
			window.location.hash = "";
			console.log(window.location);
			$(`#${name}-tab`).tab("show");
			removeExtraLinks(`${name}-tab`);
		}
		$(`.js-header-${name}`).on("click", e => {
			e.preventDefault();
			$(`#${name}-tab`).tab("show");
			removeExtraLinks(`${name}-tab`);
			$("html, body")
				.stop()
				.animate({
					scrollTop: window.pageYOffset,
				});
			window.location.assign(`/lk/#${name}`);
		});
	}

	const tabsArr = ["history", "profile", "basket"];

	for (let i = 0; i < tabsArr.length; i++) {
		actionToTab([tabsArr[i]]);
	}

	const password = $(".js-password-strength");
	const enterResult = password.parents(".enter__block").find(".enter__result");
	const enterResultText = enterResult.find(".enter__result-text");

	password.on("input", () => {
		const pass = password.val();
		const text = checkPassStrength(pass);
		let result = "";
		if (text === "weak") {
			result = "Слабый пароль. Используйте хотя бы 6 символов";
		} else if (text === "middle") {
			result = "Средний пароль";
		} else if (text === "strong") {
			result = "Сильный пароль";
		}
		enterResult.prop("className", `enter__result active ${text}`);
		enterResultText.text(result);
	});
}
